
import Modal from 'react-modal';

type ImageModalProps = {
    isOpen?: boolean;
    onCloseModal: () => void; 
    name: string;
    text?: string
  };
  
  
  
  export default function ImageModal({isOpen = false, onCloseModal, name, text}: Readonly<ImageModalProps>) {
 
    Modal.setAppElement("#root");


    return (
      <Modal isOpen={isOpen}>
        <div className="modale open">
          <div className="modale--content">
          <div className="p-md bg-blanc image-modal">
            {
              text && <p className='fz-lg p-md fw-medium'>{text}</p>
            }        
            <div className="p-md ta-center image-section">            
                <img src={process.env.REACT_APP_RESSOURCE_BASE_URL + `/img/${name}`} width="90%" height="90%" style={{boxShadow: "none"}} alt=""/>   
            </div>  
            <div className="ta-center">
                <button className="cta-bleu cta-small ml-x-md" onClick={onCloseModal}>Fermer</button>           
            </div>  
            </div>
          </div>
        </div>
      </Modal>
    );
  }